<template>
  <div>
    <div class="header-credenciado">
      <h1>{{prestador.nome}}</h1>
      <el-link @click="close" :underline="false" :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`">
        FECHAR
      </el-link>
    </div>
    <p v-if="prestador.descricao_especialidade" class="description">
      {{prestador.descricao_especialidade}}
    </p>
    <div class="address-item">
      <i class="material-icons-outlined">location_on</i>
      <div>{{prestador.enderecoCompleto}}</div>
    </div>
    <div class="address-item">
      <i class="material-icons-outlined">call</i>
      <div>
        <span v-if="prestador.telefone_primario && prestador.telefone_primario.replace(/\s/g, '').length > 0">
          {{prestador.telefone_primario}}<br/>
        </span>
        <span v-if="prestador.telefone_secundario && prestador.telefone_secundario.replace(/\s/g, '').length > 0">
          {{prestador.telefone_secundario}}<br/>
        </span>
      </div>
    </div>
    <div v-if="prestador.site_url && prestador.site_url.replace(/\s/, '').length" class="address-item">
      <i class="material-icons-outlined">open_in_new</i>
      <div>
        <el-link :style="`color: ${estilo.aplicacao.corPrimariaAplicacao};`" :href="prestador.site_url">
          {{prestador.site_url}}
        </el-link>
      </div>
    </div>
    <div v-if="!isSubstituto" class="bloqueado-alert">
      <i class="material-icons-outlined">
        block
      </i>
      <div>
        <strong>DESCREDENCIADO {{prestador.data_bloqueio ? `em ${prestador.data_bloqueio}` : ''}}</strong><br/>
        <span v-if="prestador.motivo_bloqueio">
          <strong>Motivo:</strong> {{prestador.motivo_bloqueio}}
        </span>
      </div>
    </div>
    <el-button v-if="!isSubstituto && substituto" class="substituto-btn" @click="openSubstituto">
      <span class="substituto-btn-left">
        <i class="material-icons-outlined">
          sync_alt
        </i>
        <span class="substituto-btn-name">
          Ver substituto:
        </span>
      </span>
      <i class="material-icons-outlined substituto-btn-right">
        chevron_right
      </i>
    </el-button>
    <div class="collapses">
      <el-collapse accordion class="func-listagens">
        <el-collapse-item
          class="func-62-li"
          style="margin-top: 0;"
          name="planosAtendidos"
        >
          <template slot="title" class="func-62-item">
            <el-col :span="24">
              <h2 class="func-62-title" style="margin-left: 10px">Planos atendidos</h2>
            </el-col>
          </template>
          <div class="collapse-wrapper">
            <el-skeleton v-if="isLoading" variant="text" style="width: 40%; height: 16px; margin-left: 20px;" animated />
            <el-row>
              <el-col class="func-62-item">
                {{ prestador.plano }}
                <span v-if="prestador.registro_plano_ANS">ANS: {{ prestador.registro_plano_ANS }}</span>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item
          class="func-62-li"
          style="margin-top: 0;"
          name="maisInformacoes"
        >
          <template slot="title" class="func-62-item">
            <el-col :span="24">
              <h2 class="func-62-title" style="margin-left: 10px">Mais informações</h2>
            </el-col>
          </template>
          <div class="collapse-wrapper">
            <el-row>
              <el-col :span="24" class="func-62-item">
                <span class="label-mais-detalhes">Nome fantasia</span><br>
                <span class="item-mais-detalhes">{{ prestador.nome }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Razão Social</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 40%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ prestador.razao_social }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0" v-if="prestador.apresenta_cpf === 'S'">
                <span class="label-mais-detalhes">CPF ou CNPJ</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 20%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ prestador.cpf_cnpj }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Responsável Técnico</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 40%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ __informedValue(prestador.nome_responsavel_tecnico) }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Conselho Regional {{ prestador.sigla_conselho_regional }}</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 40%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">
                  {{ prestador.sigla_conselho_regional }} - {{ prestador.numero_conselho_regional }}
                </span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Acessibilidade</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 15%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">
                  {{
                    prestador.acessibilidade === 'S' ? prestador.detalhe_acessibilidade : 'Não'
                  }}
                </span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Atendimento 24 horas</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 15%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ prestador.atend_24_horas === 'S' ? 'Sim' : 'Não' }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Regime de atendimento</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 40%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ __informedValue(prestador.regime_atendimento) }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Tipo de Prestador</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 30%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ __informedValue(prestador.descricao_tipo_prestador) }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Tipo de Estabelecimento</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 35%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ __informedValue(prestador.tipo_estabelecimento) }}</span>
              </el-col>
              <el-col :span="24" class="func-62-item" style="padding-top: 0">
                <span class="label-mais-detalhes">Observações</span><br>
                <el-skeleton-item v-if="isLoading" variant="text" style="width: 40%; height: 16px" animated />
                <span v-else class="item-mais-detalhes">{{ __informedValue(prestador.observacoes) }}</span>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { formatAddress } from '../../utils/utils'
import moment from 'moment'

export default {
  name: 'DetalhesDescredenciado',
  props: {
    bloqueado: {
      type: Object
    },
    substituto: {
      type: Object
    }
  },
  data () {
    return {
      prestador: null,
      isLoading: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao']),
    isSubstituto () {
      return this.substituto && this.prestador.id === this.substituto.id
    }
  },
  created () {
    this.setDescredenciado((this.bloqueado) ? this.bloqueado : this.substituto)
  },
  methods: {
    close () {
      if (this.bloqueado && this.isSubstituto) {
        this.openBloqueado()
      } else {
        this.$emit('close')
      }
    },
    openBloqueado () {
      this.setDescredenciado(this.bloqueado)
    },
    openSubstituto () {
      this.setDescredenciado(this.substituto)
    },
    setDescredenciado (descredenciado) {
      if (!descredenciado) return descredenciado
      this.prestador = descredenciado
      this.obterDetalhes()
    },
    async obterDetalhes () {
      this.isLoading = true
      const result = await this.apiFuncionalidade.listaDetalhesDescredenciado({
        payload: { idOperadora: this.aplicacao.idOperadora, idPrestador: this.prestador.id },
        handlerErrorIgnore: true
      })
      this.isLoading = false
      if (result.data && result.data.id === this.prestador.id) {
        this.prestador = this.handleDescredenciado({ ...this.prestador, ...result.data })
      }
    },
    handleDescredenciado (descredenciado) {
      descredenciado.data_inicio_atendimento = this.formatDate(descredenciado.data_inicio_atendimento)
      descredenciado.data_bloqueio = this.formatDate(descredenciado.data_bloqueio)

      descredenciado.enderecoCompleto = formatAddress({
        street: descredenciado.endereco,
        number: descredenciado.numero,
        complement: descredenciado.complemento,
        city: descredenciado.nome_cidade,
        state: descredenciado.id_estado,
        district: descredenciado.bairro
      })

      return descredenciado
    },
    formatDate (stringDate) {
      if (!stringDate) {
        return null
      }

      const date = moment(stringDate.split('T').shift()).locale('pt-br')

      if (!date.isValid()) {
        return null
      }

      return date.format('DD/MM/YYYY')
    },
    __informedValue (text) {
      return text && text.replace(/\s/, '').length ? text : 'Não informado'
    }
  }
}
</script>
<style lang="less">
.substituto-btn>span {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  overflow: hidden;
}
</style>
<style scoped lang="less">
.header-credenciado {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    letter-spacing: 0px;
    font-weight: 600;
    color: #333333;
    font-size: 24px;
  }
}

.address-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;

  i {
    width: 35px;
    font-size: 18px;
    opacity: 0.2;
  }
}

.bloqueado-alert {
  background: #E33333;
  border-radius: 15px;
  margin-bottom: 5px;
  padding: 15px;
  color: white!important;
  display: flex;
  align-items: center;

  strong {
    font-size: 14px;
  }

  .material-icons-outlined {
    font-size: 16px;
    padding-right: 15px;
  }
}

.substituto-btn {
  background: #09B531;
  border: none;
  color: #fff;
  width: 100%;
  border-radius: 10px;
  padding: 0;

  .substituto-btn-left {
    display: flex;
    justify-content: flex-start;
    flex-grow: 1;
    align-items: center;

    .substituto-btn-name {
      flex-grow: 1;
      text-align: left;
    }
  }

  .substituto-btn-right {
  }

  .material-icons-outlined {
    font-size: 16px;
    padding: 15px;
  }

  .description {
    margin-bottom: 15px;
  }
}

.collapses {
  margin-top: 20px;

  .collapse-wrapper {
    margin-top: 15px;
  }
}

.plans {
  padding-inline-start: revert!important;

  li {
    padding: 5px;
  }
}
</style>
